<!-- Property of OSF GLOBAL SERVICES INC. , an OSF Digital company. OSF remains the sole owner of all right, title and interest in the software. Do not copy, sell, reverse engineer or otherwise attempt to derive or obtain information about the functioning, manufacture or operation therein. -->
<style>
    .osfQuizWrapper {
        position: relative;
    }

    .osfQuizWrapper a,
    .osfQuizWrapper h2,
    .osfQuizWrapper h3,
    .osfQuizWrapper h4,
    .osfQuizWrapper h5,
    .osfQuizWrapper h6 {
        color: #333333;
    }

    .osfQuizWrapper .fade-enter-active, .osfQuizWrapper .fade-leave-active {
        transition: opacity .5s;
    }
    .osfQuizWrapper .fade-enter, .osfQuizWrapper .fade-leave-to {
        opacity: 0;
    }

    .osfQuizWrapper input {
        border: .125rem solid;
        border-radius: .375rem;
    }

    .bm-preview-container {
        width: 100%;
        padding: 12px;
        margin-right: auto;
        margin-left: auto;
    }

    /* Tablet-like screens */
    @media (min-width: 960px) {
        .bm-preview-container {
            max-width: 900px;
        }
    }

    /* Big screens */
    @media (min-width: 1264px) {
        .bm-preview-container {
            max-width: 1185px;
        }
    }
</style>

<template>
    <div
        v-if="isQuizOnline && showQuiz"
        :id="'osfquiz-' + qid"
        class="osfQuizWrapper ti-font-regular"
    >
        <loadercomp v-show="jsonLoading && !error" />
        <errorcomp v-show="error" />

        <div v-if="!jsonLoading && !error && showWelcomePage">
            <welcomecomp />
        </div>

        <div v-if="!error && showProductsPage">
            <showproductscomp />
        </div>

        <div v-if="!error && showEndPage">
            <thankyoucomp />
        </div>

        <div v-if="!error && showPrivatePage">
            <privatecomp />
        </div>

        <div v-if="!jsonLoading && !error && !showWelcomePage && !jsonLoading && !error && !showEndPage && !showPrivatePage && !showProductsPage">
            <div v-if="externalurlcomp">
                <externalurlcomp v-show="externalurlcomp" />
            </div>
            <div v-else-if="categorycomp">
                <categorycomp v-show="categorycomp" />
            </div>
            <div v-else-if="quickviewcomp">
                <quickviewcomp v-show="quickviewcomp" />
            </div>
            <div v-else-if="showproductscarouselcomp.length > 0 || showRecommendations">
                <showproductscarouselcomp v-show="showproductscarouselcomp" />
            </div>
            <div v-else>
                <questioncomp />
            </div>
        </div>
    </div>
</template>

<script>
import LoaderComp from './components/loaderComponent.vue';
import ErrorComp from './components/errorComponent.vue';
import HeadingComp from './components/headingComponent.vue';
import QuestionComp from './components/questionComponent.vue';
import WelcomeComp from './components/welcomeComponent.vue';
import ThankYouComp from './components/thankYouComponent.vue';
import PrivateComp from './components/privateComponent.vue';
import ShowProductsComp from './components/showProductsComponent.vue';
import ExternalUrlComp from './components/externalUrlComponent.vue';
import CategoryComp from './components/categoryComponent.vue';
import QuickViewComp from './components/quickViewComponent.vue';
import ShowProductsCarouselComp from './components/showProductsCarouselComponent.vue';

export default {
    name: 'Quizapp',
    components: {
        loadercomp: LoaderComp,
        errorcomp: ErrorComp,
        headingcomp: HeadingComp,
        questioncomp: QuestionComp,
        welcomecomp: WelcomeComp,
        thankyoucomp: ThankYouComp,
        privatecomp: PrivateComp,
        showproductscomp: ShowProductsComp,
        externalurlcomp: ExternalUrlComp,
        categorycomp: CategoryComp,
        quickviewcomp: QuickViewComp,
        showproductscarouselcomp: ShowProductsCarouselComp
    },
    props: ['qid', 'preview'],
    data() {
        return {
        };
    },
    computed: {
        startAPIUrl: function () {
            return window.GuidedProductFinderAPIRoutes.start;
        },
        jsonLoading: function () {
            return this.$store.state.jsonLoading;
        },
        error: function () {
            return this.$store.state.errorShow;
        },
        externalurlcomp: function () {
            return this.$store.state.externalUrl;
        },
        categorycomp: function () {
            return this.$store.state.category;
        },
        quickviewcomp: function () {
            return this.$store.state.quickview;
        },
        showWelcomePage: function () {
            return this.$store.state.showLandingPage;
        },
        showEndPage: function () {
            return this.$store.state.showEndPage;
        },
        showPrivatePage: function () {
            return this.$store.state.showPrivatePage;
        },
        showQuiz: function () {
            return this.$store.state.showQuiz;
        },
        showProductsPage: function () {
            return this.$store.state.showProductsPage;
        },
        showproductscarouselcomp: function () {
            return this.$store.state.showproductscarousel;
        },
        isQuizOnline: function () {
            if (this.preview) {
                return true;
            } if (this.$store.state.quizData) {
                return this.$store.state.quizData.online;
            }

            return true;
        },
        showRecommendations: function () {
            return this.$store.state.showRecommendations;
        }
    },
    created: function () {
        //check to reinvoke the quiz if the user is coming back from the product page
        this.$store.dispatch('loadInitialQuestion', { qid: this.qid });
    }
};
</script>
